import * as PIXI from "pixi.js";

class AppSingleton {
  private static instance: AppSingleton;
  public app: PIXI.Application;

  private constructor() {
    this.app = new PIXI.Application();
  }

  public static getInstance(): AppSingleton {
    if (!AppSingleton.instance) {
      AppSingleton.instance = new AppSingleton();
    }
    return AppSingleton.instance;
  }
}

export default AppSingleton;